
  <div class="top">
    <div class="title_search">
      <h2 class="title">Add New Landlord</h2>

      <div class="search_container">
        <input type="text"
        #search
        (click)="onSearchDialog()"

        class="default_input search" placeholder="Search" style="background:none; box-shadow:none; outline:none;"/>
        <i class="ti-search"></i>
      </div>
    </div>
    <div class="form">
      <form [formGroup]="lessorTemForm">
        <div class="the_input">
          <label for="">Ownership Title</label>
          <select formControlName="OwnershipTypeId"
          (change)="onSelectOwnershipType($event.target.value)"
          class="default_input reference-form">
            <option *ngFor="let ownershipType of ownershipTypes"
            [value]="ownershipType.id">{{ ownershipType.OwnershipTypeName }}</option>
          </select>
        </div>
        <div class="the_input">
          <label for="">Ownership Type Name</label>
          <input type="text"  (click)="onSearchDialog()" formControlName="AddressBookName" class="default_input" />
        </div>
        <button class="default_secondary-btn" *ngIf="activitySelectedValue === 'readwrite'" type="submit" [hidden]="lessorTemForm.invalid" (click)="onSubmit(lessorTemForm.value)">Create</button>
      </form>
    </div>
  </div>


